const english = [
    {   

        // home_page=========================
        Home_slider1:"Together, We Make History.",
        Home_slider2:"Don't just compete; get your voice heard!",
        Home_slider3:"The Taste of Achievement Awaits...",

        Home_secind:"Our Vision",
        Home_subheading:"Establishing You as a Prominent Political Brand",
        Home_subdescription:"In today's era, one of the most crucial elements is the concept of a 'brand'. This is because people place their trust in established brands. Therefore, Sai Digitech's primary objective is to transform our associates into prominent political brands nationwide. We are committed to ensuring the success of our partners through our expert team, specializing in election management, public relations, surveys, analysis, and campaigning. Our aim is not only to strategize but also to collaborate with them to achieve political success by elevating their brand presence.",

        Home_titles:"Our Mission",
        Home_heading:"Effective Use of Political Knowledge and Technology to Win Your Allies",
        Home_para:"We are committed to leveraging our deep understanding of technology and politics to deliver efficient services to every client. Our goal is to craft unique strategies tailored to each client, ensuring an impressive victory every time while consistently exceeding client expectations.",

        Home_card_sectiontitle:"Our Services",
        Home_card_sectionheading:"Our Winning Solutions ",
        Home_card_sectionpara:"Sai Digitek ensures your impactful presence among the masses. Our services encompass Political Research & Social Media Marketing, guaranteeing successful election campaigns.",

        Home_card1:"Data Support",
        Home_card1para:"A solid strategy hinges on reliable data. Sai Digitek offers comprehensive data support, including strategic analysis and reporting for informed decision-making.",

        Home_card2:"Social Media Support",
        Home_card2para:"Harness the power of social media with our expert team, providing captivating content and graphics in multiple languages for maximum impact.",

        Home_card3:"Election Campaign Support",
        Home_card3para:"From outdoor to indoor activities, we equip you with the tools for a successful campaign. Access voter and constituency information effortlessly with our Android and desktop software.",

        Home_know_more:"Know More",

        Home_beforefooter_para:"Every Vote Deserves Impact,",
        Home_beforefooter_para2:"We Transform Yours Into Waves!",
        Home_beforefooter_button:"Contact Us",

        // about page============================
        About_secind:"About us",
        About_subheading:"Revolutionising Political Marketing Strategies",
        About_subdescription:"Sai Digitech is a prominent firm specializing in public relations and digital marketing, with a strong focus on political campaign management and social media branding. Our approach prioritizes a deep understanding of our clients' requirements and objectives. We formulate strategies based on thorough research, surveys, and analysis, ensuring that they are customized to meet our clients' specific needs. Our expertise extends to leveraging social media platforms effectively, backed by a comprehensive assessment of our clients' backgrounds, regional dynamics, strengths, weaknesses, and competitive landscape. At Sai Digitech, our commitment goes beyond mere support; we are dedicated to the success and prosperity of our clients.",

        About_titles:"Why choose us?",
        About_heading:"Your pathway to making a resounding impact on the masses",
        About_card1:"Innovative Approach",
        About_card1para:"We prioritise aligning our strategies with your vision. Our process involves thorough client understanding, leading to the creation of winning plans.",

        About_card2:"Research-Oriented",
        About_card2para:"Understanding the electorate and constituency is key to victory. With our dedicated focus on research and analysis, we ensure a solid understanding for strategic planning.",

        About_card3:"Commitment to Excellence",
        About_card3para:"Our commitment to excellence, unique approach and research-driven strategies consistently drives us to deliver exceptional results, paving the way for your success.",

        About_fact:'',
        About_fact_text:'Realise Your Power to Make a Difference With Social Media…',

        About_beforefooter_para:"Ready To Turn Views Into Votes With Social Media? ",
        About_beforefooter_button:"Contact Us",

        // services data support ==========================
        Data_support_secind:"Data Support",
        Data_support_subheading:"Because Knowledge Is Power ",
        Data_support_subdescription:"Sai-Digitek's Data Support ensures election success with comprehensive services. We collect detailed voter data and influential contacts, analysing with SWOT and candidate-specific evaluations. Our reports provide key insights for candidate selection. Strategic planning covers all aspects, from media use to public relations, ensuring informed decision-making and effective campaigns.",

        Data_support_collection_secind:"Data Collection",
        Data_support_collection_subheading:"Know Your Voter",
        Data_support_collection_subdescription:"Knowing your voter can make a huge difference in your election campaigns. Sai Digitek will collect all the data you need & provide data-banks of the following:",
        Data_support_ul1_title1:'Voter Information:',
        Data_support_ul1_li1:"Village & City-wise",
        Data_support_ul1_li2:"Family-wise",
        Data_support_ul1_li3:"Surname-wise",
        Data_support_ul1_li4:"Booth-wise",
        Data_support_ul1_li5:"Ward-wise",
        Data_support_ul1_li6:"Address-wise",
        Data_support_ul1_li7:"Age-wise",

        Data_support_ul2_title2:'Contact Details of Influential People:',
        Data_support_ul2_li1:"Governing Bodies",
        Data_support_ul2_li2:"Assisting Committees",
        Data_support_ul2_li3:"Co-Operative Societies",
        Data_support_ul2_li4:" Influential Personalities",
        Data_support_ul2_li5:"Other Professionals",
        Data_support_ul2_li6:"Small Business Owners",
        Data_support_ul2_li7:"Political Party Leaders & Party Workers  ",

        Data_analysis_secind:"Data Analysis  ",
        Data_analysis_subheading:"NUMBERS, NARRATIVES, SUCCESS        ",
        Data_analysis_subdescription:"To get maximum output from campaign strategies, analysing the data and reaching the proper conclusions is important. Our services under Data Analysis will include:",
        Data_analysis_ul3_li1:"On-Demand Analysis",
        Data_analysis_ul3_li2:"SWOT Analysis",
        Data_analysis_ul3_li3:"Candidate-wise Analysis",
        Data_analysis_ul3_li4:"Cast-wise Analysis",
        Data_analysis_ul3_li5:"Strategic Analysis according to Panchayat Samiti  ",
        Data_analysis_ul3_li6:"Recommendations for Candidates",

      
        
        Data_candidate_survey_secind:"Candidate Survey Report",
        Data_candidate_survey_subheading:"Choose The Right One ",
        Data_candidate_survey_subdescription:"With Sai Digitek, access detailed survey reports for informed candidate choices, ensuring victory in our people-driven democracy.",
        Data_candidate_survey_ul4_li1:"Religious/Ethnic Influence",
        Data_candidate_survey_ul4_li2:"Public Expectations",
        Data_candidate_survey_ul4_li3:"Contact & Availability to the Public",
        Data_candidate_survey_ul4_li4:"Efficiency & Popularity",
        Data_candidate_survey_ul4_li5:"Strengths & Chances of Victory  ",

        Data_strategy_planning_secind:"Strategy Planning",
        Data_strategy_planning_subheading:"Plan For Victory",
        Data_strategy_planning_subdescription:"Sai Digitek ensures comprehensive strategic planning, covering all bases with keen observation and deep analysis for winning outcomes.",
        Data_strategy_planning_ul5_li1:"Selection of Suitable Candidate",
        Data_strategy_planning_ul5_li2:"Planned Publicity   ",
        Data_strategy_planning_ul5_li3:"Question Layout",
        Data_strategy_planning_ul5_li4:"Effective Media Use   ",
        Data_strategy_planning_ul5_li5:"Public Relations  ",
        Data_strategy_planning_ul5_li6:"Booth Empowerment ",
        Data_strategy_planning_ul5_li7:"Voting Process/Training ",
        Data_strategy_planning_ul5_li8:"Negative Booth Strategies  ",

         //   social media support page===========
         
         Social_media_secind:"Social Media Support",
         Social_media_support_subheading:"Why Is Social Media Important?    ",
         Social_media_support_subdescription:"In this Age of Social Media Influence, elections are no longer just about policies and speeches; they're a digital battleground where every click, like, and share shapes the political landscape. Welcome to the era where tweets carry as much weight as campaign slogans, and hashtags wield the power to sway minds. Love it or hate it, the influence of social media has forever transformed the electoral game, leaving no candidate untouched by its digital grasp. ",
         Social_media_support_ul_title:"Sai Digitek offers the following services:",
         Social_media_support_ul_li1:"Social Media Support for the following platforms: Facebook, Twitter, Instagram, WhatsApp        ",
         Social_media_support_ul_li2:"Social Media Management",
         Social_media_support_ul_li3:"Profile Creation and Management        ",
         Social_media_support_ul_li4:"Strategic written and visual content for maximum impact        ",
         Social_media_support_ul_li5:"Increasing followers and enhancing brand image        ",
         Social_media_support_ul_li6:"Establishing personal connections with audiences        ",
         Social_media_support_ul_li7:"Support for live sessions   ",
         Social_media_support_ul_li8:"Social Media Marketing Campaigns",

         Social_media_effect:"The Social Media Effect",
         Social_media_heading:"For better or worse, elections will never be the same again in this Age of Influence!",
         Social_media_para:"Over a decade, social media revolutionised electoral campaigns. Obama's `Yes We Can` mobilised masses in 2012, while Trump's viral slogans secured victory in 2016. In India, Modi's `Achhe Din Aayenge` sparked online engagement, and Fadnavis leveraged social media for sudden visibility in 2014.",

         Social_media_support_card1:"A medium to reach young minds  ",
         Social_media_support_card1para:"Reaching the elusive demographic of first-time voters is paramount in politics. Social media provides an effective avenue for connecting with this demographic.",
         Social_media_support_card2:"Creating a personal connection.",
         Social_media_support_card2para:"Leadership entails understanding and being understood by the people. Social media facilitates the cultivation of a relatable and accessible image, shaping public perception positively.         ",
         Social_media_support_card3:"Mainstream media is influenced by social media ",
         Social_media_support_card3para:"Today, social media trends wield significant influence, prompting mainstream media coverage. Harnessing this power amplifies our presence and ensures our voices resonate widely.  ",

        //  Election campaign support page=======
        Election_campaign_subheading:"A Wholesome Win Package",
        Election_campaign_subdescription:"Sai Digitek unlocks the door to timely and meticulous election campaign preparation. Our comprehensive support, including hardware and software assistance, booth support, election tools, and merchandise, ensures your campaign is executed with precision and efficiency. With our guidance, every aspect of your campaign is organised and optimised, paving the way for your success in the electoral arena.",
        Election_campaign_secind:"Election Campaign Support",

        Election_campaign_subheading1:"Tech And Time Are The Key",
        Election_campaign_subdescription1:"Sai Digitek offers essential hardware and software support for efficient election campaigns. Our android and desktop software provide instant access to voter and constituency data, saving valuable time. Additionally, our hardware support includes demo sessions on Voting Machine usage, ensuring voters are well-informed.",
        Election_campaign_secind1:"Software & Hardware Support",
        Election_campaign_ul1_li1:"Android & Desktop Software",
        Election_campaign_ul1_li2:"Voting Machine Demo Sessions",
        Election_campaign_ul1_Secind:"Software & Hardware Support",

        Election_campaign_subheading2:"LAY A GOOD FOUNDATION        ",
        Election_campaign_subdescription2:"Booths are pivotal for successful election campaigns, with strategy determining outcomes. Sai Digitek offers comprehensive support, including detailed evaluation, survey, and analysis of booths. We assist in booth formation and provide guidance and training for Booth Pramukhs and Karyakartas, ensuring effective management and voter engagement.",
        Election_campaign_secind2:"Booth Support",
        Election_campaign_ul2_li1:"Guidance & Training for Booth Pramukhs        ",
        Election_campaign_ul2_li2:"Survey, Analysis & Formation of the Booth",

        Election_campaign_subheading3:"No More Blaming The Tools        ",
        Election_campaign_subdescription3:"Sai-digitek provides comprehensive tools for impactful election campaigns, including indoor options like War Rooms and Call Centers, and outdoor strategies such as LED Vans, Audio Rickshaws, Bicycle Advertisements, and cultural performances.        ",
        Election_campaign_secind3:"Election Tools Support",
        Election_campaign_ul3_li1:"War Room        ",
        Election_campaign_ul3_li2:"Call Centre        ",
        Election_campaign_ul3_li3:"Voice Call        ",
        Election_campaign_ul3_li4:"Scheduling Campaign        ",
        Election_campaign_ul3_li5:"LED VAN        ",
        Election_campaign_ul3_li6:"Audio Rickshaw with Speakers",
        Election_campaign_ul3_li7:"	Bicycle Advertisements",
        Election_campaign_ul3_li8:"Street Shows        ",
        Election_campaign_ul3_li9:"Loka Kala (e.g., Bharud, Vasudev, etc.)        ",

        Election_campaign_subheading4:"Print, Electronic & Merchandise Support               ",
        Election_campaign_subdescription4:" ",
        Election_campaign_secind4:"",
        Election_campaign_ul4_li1:"War Room        ",
        Election_campaign_ul4_li2:"Call Centre        ",
        Election_campaign_ul4_li3:"Voice Call        ",
        Election_campaign_ul4_li4:"Scheduling Campaign        ",
        Election_campaign_ul4_li5:"LED VAN        ",
        Election_campaign_ul4_li6:"Audio Rickshaw with Speakers",
        Election_campaign_ul4_li7:"	Bicycle Advertisements",
        Election_campaign_ul4_li8:"Street Shows        ",
        Election_campaign_ul4_li9:"Loka Kala (e.g., Bharud, Vasudev, etc.)        ",

        // footer =============================
        Footer_quick:"Quick Links",
        Footer_home:"Home",
        Footer_about:"About us",
        Footer_gallery:"Gallery",
        Footer_contact:"Contact us",
        Footer_services:"Our Services",
        Footer_data:"Data support",
        Footer_social_media:"Social media support",
        Footer_election_campaign:"Election campaign support",
        Footer_Legal:"Legal",
        Footer_privacy:"Privacy policy",
        Footer_cookies:"Cookies policy",
        Footer_address:"Office no.214-216, 10 Biz park,Near symbiosis law college ,Airport road, viman nagar, pune- 411014",

        // header==============================

        Header_home:"Home",
        Header_about:"About us",
        Header_gallery:"Gallery",
        Header_contact:"Contact us",
        Header_services:"Our Services",
        Header_data:"Data support",
        Header_social_media:"Social media support",
        Header_election_campaign:"Election campaign support",

        // gallery page==================================

        Gallery_election:"Elections Posts",
        Gallery_marketing:"Marketing Posts",
        Gallery_calender:"Calender Posts",

        // contact page====================================

        Contact_heading:"Let's Make Great Beginnings!",
        Contact_para:"Kindly fill out the brief form below. Your message will be treated with utmost confidentiality by the Sai Digitek team.",
        Contact_first_name:"First Name",
        Contact_last_name:"Last Name",
        Contact_phone:"Phone",
        Contact_email:"Email",
        Conatct_msg:"Your message goes here...!",
        Contact_send:"Send Message",
        Contact_add:"Address",
        Contact_para_add:"Office no.214-216, 10 Biz park,Airport road, viman nagar, pune- 411014",

        // page not found========================================
        page_not_button:"Back to home page"


        
 





        




 
 
        
        

       
       



        
        
        

        
        




         

        
        
      


    },
];
export default english;